import ContactInformationForm from './ContactInformationForm';

export default ContactInformationForm;
